/**
 * Reached only when `status === 'paused'` — a hint exists, so a refresh cookie is presumed
 * present. If the hint has somehow gone missing by the time this renders (cleared in another tab,
 * a race on boot), there is nothing to continue: fall through to the ordinary sign-in form rather
 * than render a screen with nobody's name on it.
 */

import { readHint } from '@pos/shared';

import { AuthLayout, ContinueSessionForm, PasswordLoginForm } from '@/features/auth';

export function ContinueSessionPage() {
  const hint = readHint();

  if (hint === null) {
    return (
      <AuthLayout title="Welcome back" description="Sign in to carry on.">
        <PasswordLoginForm />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title={`Welcome back, ${hint.fullName.trim().split(/\s+/)[0] ?? hint.fullName}`}
      description="This browser was signed in as you. Pick up where you left off, or switch accounts."
    >
      <ContinueSessionForm hint={hint} />
    </AuthLayout>
  );
}
